import React, { useState, useEffect } from "react";
import EmpCard from "./EmpCard";
import { Breadcrumb, Button, message, Select, Space } from "antd";
import {
  UserPlusIcon,
  UserCircleIcon,
  HomeIcon,
} from "@heroicons/react/16/solid";
import EmpForm from "./EmpForm";
import { useDispatch, useSelector } from "react-redux";
import { getRequest } from "../../utils/APICall";
import {
  getAllDesignationStart,
  getAllDesignationSuccess,
} from "../../redux/designationSlice";
import { getAllDeptStart, getAllDeptSuccess } from "../../redux/deptSlice";
import { EmpCardSkeleton } from "./CardLoader";

const EmpPage = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [dataSet, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [skillData, setSkill] = useState([]);
  const dispatch = useDispatch();

  const { allDept } = useSelector((state) => state.dept);
  const { alldesignation } = useSelector((state) => state.designation);
  // console.log(allDept)
  const showModal = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);
  const [employeeType, setEmployeeType] = useState("current")

  const items = [
    {
      href: "/",
      title: (
        <span className="flex gap-2 items-center">
          <HomeIcon className="h-6 w-6 text-gray-500" />
          <span className="text-gray-400 sm:text-lg">Home</span>
        </span>
      ),
    },
    {
      href: "/employee",
      title: (
        <span className="flex gap-2 items-center">
          <UserCircleIcon className="h-6 w-6 text-gray-500" />
          <span className="text-gray-400 sm:text-lg">Employees</span>
        </span>
      ),
    },
  ];

  const fetchDesignations = async () => {
    try {
      dispatch(getAllDesignationStart());
      const response = await getRequest("getDesignations");
      // console.log("Designations fetched:", response);
      if (response.success) {
        dispatch(getAllDesignationSuccess(response?.data || []));
      } else {
        dispatch(getAllDesignationSuccess([]));
        // message.error(response.message || "Failed to fetch designations");
      }
    } catch (error) {
      console.error("Error fetching designations:", error);
      message.error("Error fetching designations");
    }
  };

  const fetchDepartments = async () => {
    try {
      dispatch(getAllDeptStart());
      const response = await getRequest("getAllDepartment");
      if (response.success) {
        dispatch(getAllDeptSuccess(response?.data || []));
      }
    } catch (error) {
      dispatch(getAllDeptSuccess([]));
      console.error("Error fetching departments:", error);
    }
  };

  const getAllEmp = async (employeeType) => {
    try {
     
        setIsLoader(true);
        const res = await getRequest(`getEmps?employeeType=${employeeType}`);
        // console.log("Employees fetched:", res?.data.length);

        if (res?.data) {
          setData(res.data);
          setIsLoader(false)
        } else {
          setData([]);
        }
      
    } catch (err) {
      console.error("Failed to fetch employees:", err);
      setIsLoader(false);
    } finally {
      setIsLoader(false);
    }
  };

  const getSkillnQua = async () => {
    try {
      const res = await getRequest("getability");
      // console.log("Skills & Qualifications fetched:", res);
      if (res.success) {
        setSkill(res);
      }

    } catch (err) {
      console.error("Failed to fetch skill/qualification:", err);
    }
  };

  useEffect(() => {
    fetchDesignations();
    fetchDepartments();
    getSkillnQua();
    getAllEmp(employeeType);
  }, []);

  const handleChange = (value) => {
    setEmployeeType(value)
    getAllEmp(value)
  };
  // search emp 
  const filteredEmployees = dataSet.filter((emp) =>
    emp?.FIRSTNAME?.toLowerCase().includes(searchText.toLowerCase())
  );
  // console.log("seletecd value", filteredEmployees);
  useEffect(()=>{
    getAllEmp(employeeType)
  },[employeeType])

  return (
    <div >
      <span className="flex py-4 px-2 sm:p-10 flex-wrap gap-4 justify-between items-center">
        <span className="flex flex-col gap-2 text-xl md:text-4xl font-black">
          Employee
          <Breadcrumb items={items} />
        </span>

        <span className="flex items-center gap-4" >
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search employee..."
            className="border border-gray-400 px-4 py-3 rounded-lg w-52 sm:w-64 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {/* NEW Filter Ex Current Employee */}
          <Select
            defaultValue="current"
            style={{ width: 150, height: 50, fontWeight: 'bold' }}
            onChange={handleChange}
            popupMatchSelectWidth={false}
            options={[
              { value: "ex", label: "Ex Employee" },
              { value: "current", label: "Current Employee" },
            ]}
          />

          <Button
            onClick={showModal}
            className="bg-green-400 font-bold lg:text-xl text-black py-4 px-2 sm:py-6 sm:px-4"
            variant="filled"
          >
            <UserPlusIcon className="h-6 w-6 text-gray-800" /> Add Employee
          </Button>
        </span>
      </span>

      <span className="grid grid-cols-1 justify-items-center md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {isLoader
          ?
          Array(8)
            .fill()
            .map((_, idx) => <EmpCardSkeleton key={idx} />)
          :
          filteredEmployees.length === 0 ? (
            <div className="col-span-full flex flex-col items-center justify-center py-20 space-y-3">
              <h3 className="text-lg md:text-xl font-semibold text-gray-600 dark:text-gray-300">
                No Employees Found
              </h3>

              <p className="text-sm md:text-base text-gray-400 dark:text-gray-500 max-w-xs text-center">
                Currently there are no employees matching your criteria. Please check back later or adjust your filters.
              </p>
            </div>
          ) :

            filteredEmployees.map((emp, i) => (
              <EmpCard
                key={i}
                emp={emp}
                skillData={skillData}
                deptOpt={allDept}
                desigOpt={alldesignation}
              />
            ))}
      </span>
      <EmpForm
        visible={isModalOpen}
        onClose={handleClose}
        skillData={skillData}
        deptOpt={allDept}
        desigOpt={alldesignation}
      />

    </div >

  );
};

export default EmpPage;
